// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bulletin[data-v-25de278b],.ranking-item[data-v-25de278b]{margin-bottom:10px}[data-v-25de278b] .box-card[data-v-fa5d65d4]{width:100%;height:100%}.body[data-v-25de278b]{padding:10px}", ""]);
// Exports
module.exports = exports;
